publishingApp.controller('fileCtrls', ['$scope', '$rootScope', '$window', '$timeout', '$stateParams', '$cookies', '$log', function ($scope, $rootScope, $window, $timeout, $stateParams, $cookies, $log) {
    var fileType = 'image/jpeg,image/png,image/gif',
        url = 'uploads',
        areaID = [],
        src = '',
        preview = true,
        type = 'content_image';

    var maxFileSize = $rootScope.userCan($rootScope.user.permissions, ['course-import-from-enn-zip']) ? 512 : 100;

    console.log({
        controller: "fileCtrls",
        maxFileSize: maxFileSize,
        fileTypes: fileType
    });

    $scope.dropzoneConfig = {
        'options': { // passed into the Dropzone constructor
            'url': url,
            'acceptedFiles': fileType,
            'maxFilesize': maxFileSize,
            'paramName': "file",
            'parallelUploads': 2,
            'createImageThumbnails': preview,
            'autoProcessQueue': true
        },

        'eventHandlers': {
            // This is executed before data is sent.
            'sending': function (file, xhr, formData) {

                try {
                    // Append form data
                    if (type === 'resource') {
                        formData.append('description', '');
                        formData.append('resource_id', $scope.resourceID);
                    }
                    // Set tokenin Request Headers
                    //Sending refresh token In this instance to prevent liklihood of timeout
                    var env = document.getElementById('main-doc').dataset.env;
                    xhr.setRequestHeader('Authorization', 'Bearer ' + $cookies.get('refresh_token_' + env));
                    xhr.setRequestHeader('Accept', 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8');

                    // Append data to request sent
                    formData.append('_token', $cookies.get('refresh_token_' + env));
                    formData.append('type', type);
                    formData.append('course_id', $rootScope.currentCourse);
                } catch (e) {
                    //$log.error(e);
                }

            },
            'error': function (xhr, errorMessage) {

                try {
                    $scope.$apply(function () {

                        console.log("errorMessage", errorMessage);
                        console.log("xhr", xhr);

                        if (typeof xhr === "string") {
                            $scope.pushAlerts(xhr);
                        }
                        else if (xhr.hasOwnProperty("message")) {
                            $scope.pushAlerts("Error " + xhr.status + " occurred: " + xhr.message);
                        } else if (xhr.hasOwnProperty('softErrors') || xhr.hasOwnProperty('strictErrors')) {
                            $rootScope.validate("resource_upload_entity", xhr);
                        } else if (xhr.status === "error") {
                            if (xhr.hasOwnProperty("xhr")) {
                                if (xhr.xhr.status === 422) {
                                    // Since XHR is used here, we need to parse string into an object
                                    $rootScope.validate("resource_upload_entity", JSON.parse(xhr.xhr.response));
                                }
                                else {
                                    $scope.pushAlerts("Error " + xhr.xhr.status + " occurred: " + JSON.parse(xhr.xhr.response).message);
                                }
                            }
                            else {
                                if (errorMessage) {
                                    $scope.pushAlerts(errorMessage);
                                }
                            }
                        } else {
                            $scope.pushAlerts("Unknown Error occurred. File did not upload.");
                        }
                    });
                } catch (e) {
                    //$log.error(e);
                }

            },
            'success': function (file, response) {
                try {
                    // Push Alerts
                    $scope.pushAlerts('File uploaded successfully.');

                    // Display soft errors
                    if (response.hasOwnProperty("softErrors")) {
                        if (response.softErrors != null && Array.isArray(response.softErrors) && response.softErrors.length > 0) {
                            $rootScope.validate("resource_upload_entity", response);
                        }
                    }
                } catch (e) {
                    //$log.error(e);
                }
            }
        }
    };
}]);